exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal.no-promocode .modal-body span{display:block;line-height:1.3;margin-bottom:.5rem}.modal.no-promocode a{display:block;width:100%;box-sizing:border-box;height:60px;line-height:60px;padding:0;font-size:1.25rem}", ""]);

// exports
